document.addEventListener("DOMContentLoaded", () => {
  let pageHasRecomendations =
    document.querySelector(".product-recommendations") || false;
  let timeout = pageHasRecomendations ? 2000 : 0;

  setTimeout(async function () {
    let quickViewModal = document.querySelector(".quick-view-container");

    if (quickViewModal) {
      let quickViewModalInner = quickViewModal.querySelector(".inner");
      let quickViewControls = document.querySelectorAll("[open-quick-view]");
      let quickViewClose = quickViewModal.querySelector(".close");

      let sectionName = "mm-main-product";
      // let sectionName = "test-section";
      window.addEventListener("click", async (e) => {
        const target = e.target;

        if (target.hasAttribute('open-quick-view')) {
        let handle = target.getAttribute("data-product-handle");
        if (handle) {
          e.preventDefault();
          try {
            const response = await fetch(window.Shopify.routes.root + `products/${handle}?sections=${sectionName}`);
            if (response.ok) {
              const data = await response.json();
              // let script_index = 2;
              let html = data[`${sectionName}`];
              
              const script_to_run = html.match(/<script id="qv-run">([\s\S]*?)<\/script>/gm);
              
              let script = script_to_run[0].replace("</script>", "").replace("<script id=\"qv-run\">", "");
              // script = script.replace("</div>", "");
              script = script.replace('document.addEventListener("DOMContentLoaded", () => {', "");

              let closingBraceLocation = script.lastIndexOf("});");
              script = script.substring(0, closingBraceLocation);
              
              if (quickViewModalInner && html) {
                quickViewModalInner.innerHTML = html;
                refreshFsLightbox();
                eval( script );
                document.body.style.overflow = "hidden";
                
                // init sliders
                let gallery_thumbs_swiper = new window.swiper(".inner .mobile-thumb-gallery.swiper", {
                  spaceBetween: 20,
                  slidesPerView: 2,
                  freeMode: true,
                  watchSlidesProgress: true,
            
                  navigation: {
                    nextEl: ".swiper-button-next.mobile-thumb-gallery-navigation",
                    prevEl: ".swiper-button-prev.mobile-thumb-gallery-navigation",
                  },
            
                  breakpoints: {
                    375: {
                      slidesPerView: 3,
                    },
                    500: {
                      slidesPerView: 4,
                    },
                    700: {
                      slidesPerView: 5,
                    }, 
                  },
                });

                let gallery_swiper = new window.swiper(".inner .mobile-gallery.swiper", {
                  spaceBetween: 20,
                  navigation: {
                    nextEl: ".inner .swiper-button-next.mobile-thumb-gallery-navigation",
                    prevEl: ".inner .swiper-button-prev.mobile-thumb-gallery-navigation",
                  },
                  thumbs: {
                    swiper: gallery_thumbs_swiper,
                  },
                  on: {
                    afterInit: function () {
                      document.querySelector('.inner .gallery').style.opacity = 1;
                    },
                  },
                });

                // add listeners to product form
                let productForm = quickViewModalInner.querySelector(`[action="${window.Shopify.routes.root}cart/add"]`);

                if (productForm) {
                  productForm.addEventListener("submit", function (e) {
                    e.preventDefault();

                    let quantity = productForm.querySelector("input.quantity-selector").value;
                    let id = productForm.querySelector("#product-id").value;

                    if (quantity && id) {
                      window.cart.add({ items: [{ "id": id, "quantity": quantity }] });
                      quickViewModal.classList.remove("active");
                      document.body.style.overflow = "auto";
                    }
                  });
                }


                // Show quick view modal
                quickViewModal.classList.add("active");
              }
            } else {
              throw new Error('Error: ' + response.status);
            }
          } catch (error) {
            console.error(error);
            }
          }
        }
      });
      
      quickViewClose.addEventListener("click", () => {
        quickViewModal.classList.remove("active");
        document.body.style.overflow = "auto";
      });
      
    }
  }, timeout);
});
